
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommentRepositoryInterface from '@/services/QA/comment/interfaces';

@Component({
  inject: [
    'commentRepository',
  ],
})
export default class DeleteCommentDialog extends Vue {
  @Prop() private readonly commentId!: number;
  private commentRepository!: CommentRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete the comment?`;
  }

  private async deleteComment(): Promise<void> {
    try {
      await this.commentRepository.deleteComment(this.commentId);
      this.$successDialog.show('Comment Deleted');
      this.$emit('commentDeleted', this.commentId)
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
